import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["checked", "children", "className", "cols", "disabledValues", "errorValues", "id", "isDisabled", "isMultiple", "mode", "name", "onChange", "options", "selectedValues", "size", "spacing"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { forwardRef, createContext, useContext, useState, useEffect } from 'react';
import { ThemeProvider } from 'styled-components';
import cx from 'classnames';
import { prefix } from '../../tools/settings';
import Icon from '../Icon';
import { Styled } from './VisualPicker.styles';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var VisualPickerContext = createContext();
var VisualPickerOption = forwardRef(function (_ref, ref) {
  var _cx, _option$imageAs, _option$title;

  var checked = _ref.checked,
      handleChange = _ref.handleChange,
      option = _ref.option;

  var _useContext = useContext(VisualPickerContext),
      checkedOptions = _useContext.checkedOptions,
      cols = _useContext.cols,
      disabledOptions = _useContext.disabledOptions,
      errorOptions = _useContext.errorOptions,
      isDisabled = _useContext.isDisabled,
      isMultiple = _useContext.isMultiple,
      name = _useContext.name,
      spacing = _useContext.spacing;

  var className = cx((_cx = {}, _defineProperty(_cx, "".concat(prefix, "-visualpickerOption--disabled"), isDisabled || disabledOptions[option.value]), _defineProperty(_cx, "".concat(prefix, "-visualpickerOption--hasError"), errorOptions[option.value]), _defineProperty(_cx, "".concat(prefix, "-visualpickerOption--selected"), checkedOptions[option.value]), _cx));
  var imageAs = (_option$imageAs = option === null || option === void 0 ? void 0 : option.imageAs) !== null && _option$imageAs !== void 0 ? _option$imageAs : 'image';
  return _jsx(Styled.VisualPickerOption, {
    className: className,
    cols: cols,
    spacing: spacing,
    children: _jsxs(Styled.VisualPickerLabel, {
      children: [_jsx("input", {
        type: isMultiple ? 'checkbox' : 'radio',
        name: name,
        value: option.value,
        checked: checked,
        disabled: option.disabled,
        onChange: function onChange(event) {
          return handleChange(event);
        }
      }), _jsx(Styled.Check, {
        className: "".concat(prefix, "-visualpicker__check"),
        children: _jsx(Icon, {
          size: 14,
          icon: 'tick'
        })
      }), option.image && imageAs === 'image' && _jsx(Styled.Image, {
        src: option.image,
        alt: (_option$title = option === null || option === void 0 ? void 0 : option.title) !== null && _option$title !== void 0 ? _option$title : ''
      }), option.image && imageAs === 'icon' && _jsx(Icon, {
        size: 32,
        icon: option.image,
        color: "var(--dentsu-color-blue)"
      }), _jsxs(Styled.Title, {
        hasImage: option.image ? true : false,
        children: [_jsx("strong", {
          children: option.title
        }), option.subtitle]
      })]
    })
  });
});
var VisualPicker = forwardRef(function (_ref2, ref) {
  var _cx2;

  var _ref2$checked = _ref2.checked,
      checked = _ref2$checked === void 0 ? false : _ref2$checked,
      children = _ref2.children,
      customClassName = _ref2.className,
      _ref2$cols = _ref2.cols,
      cols = _ref2$cols === void 0 ? 3 : _ref2$cols,
      _ref2$disabledValues = _ref2.disabledValues,
      disabledValues = _ref2$disabledValues === void 0 ? [] : _ref2$disabledValues,
      _ref2$errorValues = _ref2.errorValues,
      errorValues = _ref2$errorValues === void 0 ? [] : _ref2$errorValues,
      id = _ref2.id,
      _ref2$isDisabled = _ref2.isDisabled,
      isDisabled = _ref2$isDisabled === void 0 ? false : _ref2$isDisabled,
      _ref2$isMultiple = _ref2.isMultiple,
      isMultiple = _ref2$isMultiple === void 0 ? false : _ref2$isMultiple,
      _ref2$mode = _ref2.mode,
      mode = _ref2$mode === void 0 ? 'light' : _ref2$mode,
      name = _ref2.name,
      _ref2$onChange = _ref2.onChange,
      onChange = _ref2$onChange === void 0 ? function () {
    return null;
  } : _ref2$onChange,
      _ref2$options = _ref2.options,
      options = _ref2$options === void 0 ? [] : _ref2$options,
      _ref2$selectedValues = _ref2.selectedValues,
      selectedValues = _ref2$selectedValues === void 0 ? [] : _ref2$selectedValues,
      _ref2$size = _ref2.size,
      size = _ref2$size === void 0 ? 'medium' : _ref2$size,
      _ref2$spacing = _ref2.spacing,
      spacing = _ref2$spacing === void 0 ? 16 : _ref2$spacing,
      rest = _objectWithoutProperties(_ref2, _excluded);

  var className = cx((_cx2 = {}, _defineProperty(_cx2, "".concat(prefix, "-visualpicker"), true), _defineProperty(_cx2, customClassName, !!customClassName), _defineProperty(_cx2, "".concat(prefix, "-visualpicker--disabled"), isDisabled), _cx2));

  var _useState = useState(function () {
    var checkedOptionsFromProp = {};

    var _iterator = _createForOfIteratorHelper(selectedValues),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var value = _step.value;
        checkedOptionsFromProp[value] = true;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return checkedOptionsFromProp;
  }),
      _useState2 = _slicedToArray(_useState, 2),
      checkedOptions = _useState2[0],
      setCheckedOptions = _useState2[1];

  var _useState3 = useState(function () {
    var errorOptionsFromProps = {};

    var _iterator2 = _createForOfIteratorHelper(errorValues),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var value = _step2.value;
        errorOptionsFromProps[value] = true;
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }

    return errorOptionsFromProps;
  }),
      _useState4 = _slicedToArray(_useState3, 1),
      errorOptions = _useState4[0];

  var _useState5 = useState(function () {
    var disabledOptionsFromProps = {};

    var _iterator3 = _createForOfIteratorHelper(disabledValues),
        _step3;

    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var value = _step3.value;
        disabledOptionsFromProps[value] = true;
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }

    return disabledOptionsFromProps;
  }),
      _useState6 = _slicedToArray(_useState5, 1),
      disabledOptions = _useState6[0];

  var handleChange = function handleChange(event) {
    var updatedCheckedOptions;

    if (isMultiple) {
      updatedCheckedOptions = _objectSpread(_objectSpread({}, checkedOptions), {}, _defineProperty({}, event.target.value, event.target.checked));
      setCheckedOptions(updatedCheckedOptions);
    } else {
      updatedCheckedOptions = _defineProperty({}, event.target.value, event.target.checked);
      setCheckedOptions(updatedCheckedOptions);
    }

    onChange(Object.keys(updatedCheckedOptions).filter(function (checked) {
      return updatedCheckedOptions[checked];
    }));
  };

  useEffect(function () {
    setCheckedOptions(function () {
      var checkedOptionsFromProp = {};

      var _iterator4 = _createForOfIteratorHelper(selectedValues),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var value = _step4.value;
          checkedOptionsFromProp[value] = true;
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }

      return checkedOptionsFromProp;
    });
  }, [selectedValues]);
  return _jsx(ThemeProvider, {
    theme: {
      mode: mode,
      size: size
    },
    children: _jsx(VisualPickerContext.Provider, {
      value: {
        checkedOptions: checkedOptions,
        cols: cols,
        disabledOptions: disabledOptions,
        errorOptions: errorOptions,
        isDisabled: isDisabled,
        isMultiple: isMultiple,
        name: name,
        spacing: spacing
      },
      children: _jsx(Styled.VisualPicker, _objectSpread(_objectSpread({
        ref: ref,
        className: className,
        cols: cols,
        id: id,
        selectedValues: selectedValues,
        spacing: spacing
      }, rest), {}, {
        children: options.map(function (option) {
          return _jsx(VisualPickerOption, {
            checked: checkedOptions[option.value] || checked,
            option: option,
            handleChange: handleChange
          }, option.value);
        })
      }))
    })
  });
});
VisualPicker.Option = VisualPickerOption;
export default VisualPicker;